'use client'

import { createContext, PropsWithChildren, useContext } from 'react'

type Context = {
  API_URL?: string
  BACKEND_URL?: string
  CARGOKING_SHIPPER_URL?: string
  GOOGlE_API_KEY?: string
  KCHARLES_URL?: string
  POSTHOG_HOST?: string
  POSTHOG_KEY?: string
  PUSHER_APP_KEY?: string
  PUSHER_CLUSTER?: string
  PUSHER_WS_HOST?: string
  PUSHER_WS_PORT?: string
  SOURCE?: string
}

const Context = createContext({} as Context)

export const DotEnvProvider = ({ children, env }: PropsWithChildren<{ env: Context }>) => {
  return <Context.Provider value={env}>{children}</Context.Provider>
}

export const useDotEnv = () => {
  const context = useContext(Context)

  if (!context) {
    throw new Error('useDotEnv must be used within a DotEnvProvider')
  }

  return context
}
